export const VIDEO_REQUEST = "VIDEO_REQUEST"
export const VIDEO_SUCCESS = "VIDEO_SUCCESS"
export const VIDEO_FAIL = "VIDEO_FAIL"
